import React from 'react'

interface DoneSVGProps {
    size?: number
}

const DoneSVG: React.FC<DoneSVGProps> = ({ size = 16 }) => {
    const S: number = Number.isNaN(Number(size)) ? 16 : Number(size)
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={S} height={S * (5 / 7)} fill="none" aria-hidden="true" className="your-class">
            <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="m6 .496-3.438 4L1 2.678" />
        </svg>
    )
}

export default DoneSVG
